module.exports = __webpack_public_path__ + "static/img/attention.0198916c.svg";